import { fmtDuracion, type KpisDia as Kpis } from '@/lib/llamadas/presentacion';
import type { DeltaPeriodo } from '@/lib/cuadro/agregaciones';
import { Icono } from '../Layout/iconos';

// KPIs del periodo (prototipo: kLlam/kRes/kEsc/kTm + delta kLlamD). Misma
// composición de tarjeta que los KPIs del día de Atención.

function Tarjeta({
  icono,
  etiqueta,
  children,
  pie,
}: {
  icono: string;
  etiqueta: string;
  children: React.ReactNode;
  pie?: React.ReactNode;
}) {
  return (
    <div className="min-w-0 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] px-4 py-[15px] shadow-[var(--shadow-soft)]">
      <div className="mb-[11px] flex min-h-[30px] items-start gap-2 text-[var(--text-dim)]">
        <Icono nombre={icono} className="mt-px h-[15px] w-[15px] shrink-0" />
        <span className="text-[11.5px] font-medium leading-tight">{etiqueta}</span>
      </div>
      <div className="mono text-[28px] font-semibold leading-none tracking-[-0.6px] text-[var(--navy)]">
        {children}
      </div>
      {pie && <div className="mt-2 text-[11.5px] text-[var(--text-dim)]">{pie}</div>}
    </div>
  );
}

export function KpisCuadro({ kpis, delta }: { kpis: Kpis; delta: DeltaPeriodo }) {
  return (
    <section className="mb-[18px] grid grid-cols-2 gap-[13px] xl:grid-cols-4 print:grid-cols-4">
      <Tarjeta
        icono="phone"
        etiqueta="Llamadas atendidas"
        pie={
          delta.pct === null ? (
            'sin periodo previo comparable'
          ) : (
            <span
              style={{
                color:
                  delta.direccion === 'baja' ? 'var(--status-esc-ink)' : 'var(--status-ok-ink)',
              }}
              className="font-semibold"
            >
              {delta.direccion === 'sube' ? '▲' : delta.direccion === 'baja' ? '▼' : '='}{' '}
              {Math.abs(delta.pct)}% vs periodo anterior
            </span>
          )
        }
      >
        {kpis.total}
      </Tarjeta>
      <Tarjeta
        icono="check"
        etiqueta="Resueltas por IA"
        pie={
          <span className="block h-1 overflow-hidden rounded-full bg-[var(--surface-3)]">
            <span
              className="block h-full rounded-full bg-[var(--status-ok)]"
              style={{ width: `${kpis.resueltasPct ?? 0}%` }}
            />
          </span>
        }
      >
        {kpis.resueltasPct === null ? '—' : <>{kpis.resueltasPct}%</>}
      </Tarjeta>
      <Tarjeta icono="escalate" etiqueta="Escaladas" pie="a operaciones · comercial">
        {kpis.escaladas}
      </Tarjeta>
      <Tarjeta icono="clock" etiqueta="Tiempo medio" pie="por llamada">
        {fmtDuracion(kpis.duracionMediaS)}
      </Tarjeta>
    </section>
  );
}
